import React, { useState, useEffect } from 'react'
import { Box, Text, Image, Flex, Button } from '@chakra-ui/react'
import { PublicClientApplication } from '@azure/msal-browser'
import {
  msalVicOneLocal,
  msalVicOne,
  msalConfigLocal,
  msalConfigPRD,
  msalConfigSTG,
} from './authConfig'
import styles from './appStyles'
import './App.css'

export const Login = ({ setMsalConfig, msalConfig }) => {
  const [isStaging, setIsStaging] = useState(false)

  const msalTMConfig = () => {
    if (process.env.REACT_APP_ENV === 'staging') {
      console.log('msal-stg-tm')
      return msalConfigSTG
    } else if (process.env.REACT_APP_ENV === 'develop') {
      console.log('msal-local-tm')
      return msalConfigLocal
    }

    return msalConfigPRD
  }

  const msalCVConfig = () => {
    if (process.env.REACT_APP_ENV === 'develop') {
      console.log('msal-local-vicone')
      return msalVicOneLocal
    }
    return msalVicOne
  }

  const handleVicOneLogin = async () => {
    setMsalConfig(msalCVConfig())
  }

  const handleTrendMicroLogin = async () => {
    setMsalConfig(msalTMConfig())
  }

  useEffect(() => {
    setIsStaging(() => {
      if (process.env.REACT_APP_ENV !== 'production') {
        return true
      }
    })

    try {
      const instance = new PublicClientApplication(msalConfig)

      if (msalConfig.auth.clientId != '') {
        instance
          .loginPopup({
            scopes: ['User.Read'],
            authority: 'https://login.microsoftonline.com/organizations',
          })
          .then(() => {
            window.location.reload()
          })
      }
    } catch (error) {
      console.log('login error: ', {
        error,
        msalConfig,
      })
    }
  }, [msalConfig])

  return (
    <Box>
      <Box
        w="100%"
        h="200"
        bgGradient="linear(to-b, #fff 25%,#b9d3e9 40%, #2059b4 90%)"
      >
        <Box style={styles.headerContainer}>
          <Image src="assets/logo.png" alt="icon" style={styles.logoSize} />

          <Text
            color={'#000'}
            style={{ marginLeft: 10 }}
            fontSize="2xl"
            as="i"
            fontWeight={'500'}
          >
            TrendLabs
          </Text>
          <Text
            color={'#000'}
            style={{ marginLeft: 5 }}
            fontSize="2xl"
            fontWeight={'200'}
          >
            app store {isStaging ? ' [STG]' : null}
          </Text>
        </Box>
        <Box padding={5} paddingLeft={8}>
          <Box w="100%">
            <Text
              color={'#fff'}
              fontSize="xl"
              lineHeight={1}
              textAlign="center"
            >
              All-in-one platform for the Trender's needs.
            </Text>
          </Box>
          <Box w="100%" marginTop={5}>
            <Text
              color={'#00FFFF'}
              fontSize="xl"
              lineHeight={1}
              fontWeight="700"
              textAlign="center"
            >
              State of the art apps engineered for Trenders.
            </Text>
          </Box>
        </Box>
      </Box>

      <Flex
        style={{
          flexDirection: 'column',
          paddingTop: 10,
          paddingBottom: 10,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box>
          <Text
            style={{
              fontSize: 22,
            }}
          >
            Select domain:
          </Text>
        </Box>
        <Flex
          style={{
            marginTop: 10,
            justifyContent: 'space-evenly',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Button
            colorScheme="teal"
            variant="outline"
            style={{ padding: 30, height: 30, marginBottom: 10 }}
            onClick={handleTrendMicroLogin}
          >
            <Text
              style={{
                fontSize: 18,
              }}
            >
              Trend Micro Inc.
            </Text>
          </Button>
          <Button
            colorScheme="teal"
            variant="outline"
            style={{ padding: 30, height: 30 }}
            onClick={handleVicOneLogin}
          >
            <Text
              style={{
                fontSize: 18,
              }}
            >
              VicOne Inc.
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Login
